import styles from './NumberEducationCard.module.scss'
import { Responsive } from '../Responsive/Responsive'
import { Button } from '@120wateraudit/envirio-components'
import { Icon, Modal } from 'semantic-ui-react'
import React from 'react'

export class NumberEducationCard extends React.Component<any> {
  state = { isModalOpen: false }

  render() {
    const { isModalOpen } = this.state

    return (
      <>
        <Responsive platform="mobile">
          <div className="buildingBlock">
            <Button
              size="small"
              onClick={this.toggleModal}
              className={styles.modalButton}
            >
              What do these numbers mean? <Icon name="question circle" />
            </Button>
          </div>

          <Modal
            open={isModalOpen}
            onClose={this.toggleModal}
            closeOnDimmerClick={true}
            className={styles.modal}
          >
            <Modal.Header>
              <div className={styles.modalHeader}>
                <h3>What do these numbers mean?</h3>
                <button
                  className={styles.exitButton}
                  onClick={() => this.close()}
                >
                  &times;
                </button>
              </div>
            </Modal.Header>
            <Modal.Content>{this.educationContentRenderer()}</Modal.Content>
          </Modal>
        </Responsive>
        <Responsive platform="desktop">
          <div className={styles.numberEducationCardWrapper + ' buildingBlock'}>
            <h3>What do these numbers mean?</h3>
            {this.educationContentRenderer()}
          </div>
        </Responsive>
      </>
    )
  }

  private toggleModal = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen })
  }

  private close = () => {
    this.setState({ isModalOpen: false })
  }

  private educationContentRenderer = (): JSX.Element => {
    return (
      <>
        <p>
          These Lead Results are in <b>parts per billion (ppb)</b>. For
          reference, 1 ppb would be 1 part of lead for every billion parts of
          water (roughly one drop of water in an olympic-sized swimming pool).
          If the result is <b> 0.5 ppb</b>, this means the lab could not detect
          lead in the sample.
        </p>
        <p>
          The results in red were above our remediation threshold. Finding lead
          sources takes time and can be complicated. You can see what
          remediation measures were taken in the Remediation column.
        </p>
        <p>
          <a
            target="_blank"
            href={`https://www.cdc.gov/nceh/lead/prevention/sources/water.htm`}
          >
            Check out the CDC's website
          </a>{' '}
          to learn more about lead in drinking water.
        </p>
      </>
    )
  }
}
